import { Time } from '@britishcouncil/react-common';

const endOfDay24hoursTime = '24:00';
const midnightTime = '00:00';

export const getMinLrwSessionEndTime = (startTime: string): string => {
  return (
    (startTime === '23:30'
      ? endOfDay24hoursTime
      : Time.fromString(startTime)?.addMinutes(30).toString()) ?? '00:30'
  );
};

export const fromApiSessionEndTime = (time: string): string => {
  const [hours = '00', minutes = '00'] = time.split(':');
  const result = `${hours}:${minutes}`;

  return result === midnightTime ? endOfDay24hoursTime : result;
};

export const fromApiSessionStartTime = (time: string): string => {
  const [hours = '00', minutes = '00'] = time.split(':');
  const result = `${hours}:${minutes}`;

  return result === endOfDay24hoursTime ? midnightTime : result;
};

export const toApiSessionTime = (time: string): string => {
  const normalizedTime = time === endOfDay24hoursTime ? midnightTime : time;

  return `${normalizedTime}:00`;
};
